import { getTimeZones, TimeZoneName } from '@vvo/tzdb';
import { MDSDropdownItem } from '@marqvision/mds-v2';

const list = new Map<TimeZoneName, MDSDropdownItem<TimeZoneName>>(
  getTimeZones().map((tz) => {
    const offsetMinutes = tz.currentTimeOffsetInMinutes;
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const hours = String(Math.floor(Math.abs(offsetMinutes) / 60)).padStart(2, '0');
    const minutes = String(Math.abs(offsetMinutes) % 60).padStart(2, '0');

    const utcLabel = `(UTC${sign}${hours}:${minutes})`;
    const cities = tz.mainCities.slice(0, 3).join(', ');

    const item = {
      label: `${utcLabel} ${cities}`,
      value: tz.name,
    };

    return [tz.name, item];
  })
);

/**
 * 타임존 관련 유틸리티 객체
 * 전 세계 타임존 목록과 관련 기능을 제공합니다.
 * 데이터 출처: https://github.com/vvo/tzdb
 */
export const Timezone = {
  /**
   * 모든 타임존의 목록을 반환합니다.
   * 각 항목은 라벨, 값, 그리고 타임존 데이터를 포함합니다.
   */
  list: list.values().toArray(),

  /**
   * 주어진 타임존 이름에 해당하는 표시용 라벨을 반환합니다.
   *
   * @param value - 타임존 이름 (예: "Asia/Seoul")
   * @returns 타임존의 표시용 라벨 또는 찾을 수 없는 경우 원본 값
   */
  getLabel: (value: TimeZoneName) => {
    const item = list.get(value);
    return item ? item.label : value;
  },

  /**
   * 현재 시스템의 타임존을 반환합니다.
   *
   * @example
   * ```typescript
   * console.log(Timezone.current); // "Asia/Seoul" (한국 시간대인 경우)
   * ```
   */
  current: Intl.DateTimeFormat().resolvedOptions().timeZone as TimeZoneName,
};
